import { useCallback } from 'react';
import { prop } from 'ramda';
import { useGetURLTemplate } from 'server';
import { useAppSelector, useGameConfigurationSelector } from 'js/store/hooks';
import { useShowNotification } from 'js/hooks/useShowNotification';
import { useOnClose } from 'js/components/common/PopupManager/hooks';

import { getButtons } from './helpers';
import { useGetSubmitAdvancedDialog } from '../useGetSubmitAdvancedDialog';

export const useGetButtons = () => {
    const onClose = useOnClose();
    const getURLTemplate = useGetURLTemplate();
    const showNotification = useShowNotification();
    const submitAdvancedDialog = useGetSubmitAdvancedDialog();
    const games = useGameConfigurationSelector(prop('games'));
    const cashierUrlTemplates = useAppSelector(prop('cashierUrlTemplates'));

    return useCallback(({
        buttons,
        actionId,
        windowSessionId
    }) => getButtons({
        actionId,
        windowSessionId,
        buttons,
        onClose,
        submitAdvancedDialog,
        showNotification,
        games,
        urlTypeList: cashierUrlTemplates,
        getURLs: getURLTemplate
    }), [
        onClose, submitAdvancedDialog, getURLTemplate, showNotification, games, cashierUrlTemplates
    ]);
};
